import { Component, computed, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { MatBadgeModule } from '@angular/material/badge';

@Component({
  selector: 'app-notifications-button',
  imports: [
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatBadgeModule,
    TranslatePipe,
  ],
  templateUrl: './notifications-button.html',
  styleUrl: './notifications-button.scss'
})

export class NotificationsButton {
  public readonly badge = computed(() => (this.notificationsCount() > 0) ? this.notificationsCount().toString() : '');
  private readonly notificationsCount = signal(0);
  //private readonly appService = inject(AppService);
  //private readonly authService = inject(AuthService);

  constructor() {
    // this.authService.getEmployeeId().pipe(
    //   switchMap(employeeId => this.appService.getCount(employeeId)),
    //   tap(cnt => this.notificationsCount.set(cnt)),
    // ).subscribe()
  }  

}
